// extracted by mini-css-extract-plugin
export default {"wrapper":"UpgradeHiro_wrapper__RwfrR"};